export default __webpack_public_path__ + "5d9b6ea033f13174bcddd03813979504.png";